// extracted by mini-css-extract-plugin
export default {"card":"card-WY05g","cardTitle":"cardTitle-F8G8a","imageBlock":"imageBlock-MC0yk","description":"description-CxtwJ","ssSubTitle":"ssSubTitle-MLFTE"};